<template>
<b-modal id="play-modal" size="lg" :title="item.title + ' - ' + item.category">
    <div class="modal-body"> 
        <div v-for="(line, index) in item.lines" :key="index">
            {{ index+1 }}. {{ line.text }} <span class="mute-tag">({{ line.owner.substr(line.owner.length-4, 4) }})</span>
        </div>
    </div>
    <div slot="modal-footer" class="modal-footer-inner">
        <div class="mb-3">
            <input v-model="line" type="text" class="form-control" placeholder="Add New Line">
        </div>
        <button type="button" class="btn btn-secondary" @click="hideModal">
            Close
        </button>
        <button v-if="!pendingTransaction" type="button" class="btn btn-primary" @click="submitTransaction">
            Submit
        </button>
        <button v-else class="btn btn-secondary">
            Please wait ...
        </button>   
    </div>
</b-modal>
</template>
 
<script>
import { mapGetters } from "vuex";


export default {
    name: "modal-play",
    data () {
        return {
            line: ''
        }
    },
    computed: {
        ...mapGetters({
            item: 'getItem',
            pendingTransaction: 'getPendingTransaction'
        })  
    },
    methods: {
        hideModal () {
            this.$root.$emit('bv::hide::modal','play-modal');
        },

        selectLetter (letter) {
            if (this.selectedLetters.length == 2) {
                this.selectedLetters.splice(0, 1);
            }
            this.selectedLetters.push(letter);
        },

        submitTransaction () {
            const id = this.item.id;
            const line = this.line;

            if (line.replace(/\s/g, '') == '') {
                this.$notify({
                    group: "app",
                    title: "Warning!",
                    text: 'Please provide a new line!'
                });

                return;
            }

            this.$store.commit('updatePendingTransaction', { status: true });
            this.$store.dispatch('updateStory', { id, line }).then((response) => {

                if (response.message == 'success') {

                    this.$notify({
                        group: "app",
                        title: "Success!",
                        text: 'You have added a new line!'
                    });

                } else if (response.message == 'error') {

                    this.$notify({
                        group: "app",
                        title: "Warning!",
                        text: 'There was an error with your transaction'
                    });

                } else {

                    this.$notify({
                        group: "app",
                        title: "Warning!",
                        text: 'There was a problem loading your data, please refresh'
                    });

                }

                this.$store.commit('updatePendingTransaction', { status: false });
                this.line = '';

            });

        }
    }
};
</script>

<style scoped lang="less">
.form-control {
    border-radius: 0;
    margin: 5px;
}

.word-display {
    .letter {
        margin: 5px;
        padding: 20px 10px;
        border: 1px solid #ccc;
    }
}

.letter-selection {
    border-top: 1px solid #efefef;
    padding-top: 30px;
    margin-top: 30px;

    .letter {
        cursor: pointer;
        padding: 20px 10px;
        border: 1px solid #ccc;
        margin: 5px;
        &:hover {
            background: #efefef;
        }

        &.selected {
            background: #ccc;
            color: #fff;
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/components/ModalPlay.vue